export const officerItems: {
  title: string
  name: string
  profile: {
    date: string
    content: string | JSX.Element
  }[]
}[] = [
  {
    title: '代表取締役社長',
    name: '永田 洋幸',
    profile: [
      {
        date: '2009年8月',
        content: '株式会社トライアルカンパニー入社',
      },
      {
        date: '2012年5月',
        content: 'Trial Retail Engineering, Inc.経営企画部長',
      },
      {
        date: '2018年11月',
        content: '株式会社Retail AI代表取締役CEO就任',
      },
      {
        date: '2020年9月',
        content: '当社取締役就任',
      },
      {
        date: '2021年10月',
        content: '当社カンパニーコミュニケーション部長',
      },
      {
        date: '2025年4月',
        content: '当社代表取締役社長就任（現任）',
      },
      {
        date: '2026年4月',
        content: '株式会社トライアルカンパニー代表取締役社長就任（現任）',
      },
    ],
  },
  {
    title: '取締役',
    name: '石橋 亮太',
    profile: [
      {
        date: '1999年1月',
        content: '株式会社ティーアールイー入社',
      },
      {
        date: '1999年7月',
        content: '株式会社トライアルカンパニー転籍',
      },
      {
        date: '2004年8月',
        content: '煙台創迹軟件有限公司董事長',
      },
      {
        date: '2011年8月',
        content: '株式会社トライアルカンパニー販売本部小型フォーマット事業部長',
      },
      {
        date: '2015年6月',
        content: '同社取締役就任 商品本部ＴＣＭ統括',
      },
      {
        date: '2016年12月',
        content: '同社取締役副社長就任',
      },
      {
        date: '2018年6月',
        content: (
          <>
            同社代表取締役社長就任
            <br />
            当社取締役就任（現任）
          </>
        ),
      },
      {
        date: '2026年4月',
        content: '株式会社トライアルテクノロジー代表取締役社長就任（現任）',
      },
    ],
  },
  {
    title: '社外取締役',
    name: '立本 博文',
    profile: [
      {
        date: '2002年10月',
        content: '東京大学先端科学技術研究センター助手',
      },
      {
        date: '2004年4月',
        content: '東京大学経済学部ものづくり経営研究センター助教',
      },
      {
        date: '2009年4月',
        content: '兵庫県立大学経営学部准教授',
      },
      {
        date: '2010年9月',
        content: 'MIT客員研究員（Sloan school of management）',
      },
      {
        date: '2012年10月',
        content: '筑波大学ビジネスサイエンス系准教授',
      },
      {
        date: '2016年4月',
        content: '筑波大学ビジネスサイエンス系教授（現任）',
      },
      {
        date: '2019年1月',
        content: '株式会社Retail AI社外取締役就任',
      },
      {
        date: '2020年9月',
        content: '当社社外取締役就任（現任）',
      },
      {
        date: '2026年4月',
        content: '株式会社トライアルテクノロジー社外取締役就任（現任）',
      },
    ],
  },
  {
    title: '社外取締役',
    name: '張  相秀',
    profile: [
      {
        date: '1981年6月',
        content: '韓国産業経済研究院入職',
      },
      {
        date: '1991年6月',
        content: 'サムスン経済研究所入所',
      },
      {
        date: '2013年4月',
        content: '亜細亜大学経営学部特任教授',
      },
      {
        date: '2016年4月',
        content: '亜細亜大学都市創造学部専任教授',
      },
      {
        date: '2022年9月',
        content: '当社社外取締役就任（現任）',
      },
    ],
  },
  {
    title: '常勤監査役',
    name: '上里 剛志',
    profile: [
      {
        date: '1996年4月',
        content: '株式会社福岡銀行入行',
      },
      {
        date: '2018年12月',
        content:
          '株式会社トライアル・シェアードサービス入社 財務経理本部財務部副部長',
      },
      {
        date: '2019年3月',
        content: '株式会社トライアル開発 執行役員副社長',
      },
      {
        date: '2020年3月',
        content: '当社グループ経営戦略部経営戦略室副室長',
      },
      {
        date: '2021年6月',
        content: (
          <>
            当社常勤監査役就任（現任）
            <br />
            株式会社トライアルカンパニー監査役就任（現任）
            <br />
            株式会社Retail AI監査役就任（現任）
          </>
        ),
      },
      {
        date: '2025年11月',
        content:
          '株式会社TRIALS（現　株式会社トライアルテクノロジー）監査役就任（現任）',
      },
    ],
  },
  {
    title: '社外監査役',
    name: '橋本 道成',
    profile: [
      {
        date: '2006年11月',
        content: '最高裁判所司法研修所入所',
      },
      {
        date: '2007年12月',
        content: (
          <>
            弁護士登録
            <br />
            弁護士法人北浜法律事務所入所
          </>
        ),
      },
      {
        date: '2017年1月',
        content:
          '如水法律事務所（現 弁護士法人如水法律事務所）設立 代表（現任）',
      },
      {
        date: '2020年6月',
        content: '当社社外監査役就任（現任）',
      },
      {
        date: '2020年11月',
        content: '株式会社SENTAN Pharma社外取締役',
      },
      {
        date: '2020年12月',
        content: 'ニッポンインシュア株式会社社外監査役（現任）',
      },
      {
        date: '2021年5月',
        content: '株式会社キャム社外監査役（現任）',
      },
      {
        date: '2021年8月',
        content:
          '株式会社QPS研究所（現　株式会社QPSホールディングス）社外取締役（監査等委員、現任）',
      },
      {
        date: '2026年6月',
        content: 'Delta-Fly Pharma株式会社社外監査役就任（現任）',
      },
    ],
  },
  {
    title: '社外監査役',
    name: '薄鍋 大輔',
    profile: [
      {
        date: '2008年12月',
        content: '仰星監査法人入所',
      },
      {
        date: '2012年9月',
        content: '公認会計士登録',
      },
      {
        date: '2015年6月',
        content: '薄鍋公認会計士事務所設立 （現任）',
      },
      {
        date: '2015年11月',
        content: (
          <>
            税理士登録
            <br />
            薄鍋大輔税理士事務所設立
          </>
        ),
      },
      {
        date: '2021年9月',
        content: '当社社外監査役就任（現任）',
      },
      {
        date: '2022年8月',
        content: '木原税理士法人所属税理士',
      },
      {
        date: '2024年8月',
        content: '木原税理士法人社員税理士（現任）',
      },
    ],
  },
]
